import Framework from '@greenville/framework';
import { Autocomplete } from '@mui/material';
import {
  Checkbox,
  FormGroup,
  Grid,
  ListItem,
  // ListItemText,
  TextField,
  TextareaAutosize,
  makeStyles
} from '@material-ui/core';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import * as constants from '../../../common/constants';
import env from '../../../common/env';
import utils from '../../../common/utils';
import AutocompleteComponent from '../../chatUtility/common/components/Autocomplete';

const useStyles = makeStyles({
  flexBorder: {
    border: '1px solid grey',
    margin: '75px',
    borderRadius: '4px',
    paddingTop: '9px'
  },
  gridColumns: {
    display: 'flex',
    justifyContent: 'center'
  },
  flexContainerBottom: {
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid grey',
    borderBottom: '1px solid grey',
    padding: '10px'
  },
  ButtonClass: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%'
  },
  labelColumns: {
    display: 'flex',
    justifyContent: 'start',
    paddingLeft: '60px',
    paddingBottom: '10px'
  },
  subLable: {
    fontWeight: '600 !important',
    fontSize: '14px !important',
    width: '100%',
    marginTop: '5px',
    marginBottom: '5px !important'
  },
  flexContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid grey'
  },
  versionText: {
    fontSize: '10px',
    fontStyle: 'italic',
    textDecoration: 'underline'
  },
  tabTitleRow: {
    marginBottom: '8px',
    paddingBottom: '10px',
    borderBottom: '2px solid #005d83'
  },
  tabContainer: {
    display: 'flex',
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    margin: '20px 0',
    minHeight: '300px',
    backgroundColor: '#fff',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      minHeight: '200px'
    }
  },
  tabNavigation: {
    width: '250px',
    backgroundColor: '#f5f5f5',
    borderRight: '1px solid #e0e0e0',
    display: 'flex',
    flexDirection: 'column',
    '@media (max-width: 768px)': {
      width: '100%',
      flexDirection: 'row',
      borderRight: 'none',
      borderBottom: '1px solid #e0e0e0',
      overflowX: 'auto'
    }
  },
  tabButton: {
    padding: '16px 20px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666',
    borderBottom: '1px solid #e0e0e0',
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#e8f4f8',
      color: '#333'
    },
    '@media (max-width: 768px)': {
      minWidth: '150px',
      textAlign: 'center',
      borderBottom: 'none',
      borderRight: '1px solid #e0e0e0',
      '&:last-child': {
        borderRight: 'none'
      }
    }
  },
  tabButtonActive: {
    backgroundColor: '#005d83',
    color: '#fff',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#004a6b',
      color: '#fff'
    }
  },
  tabContent: {
    flex: 1,
    padding: '24px',
    backgroundColor: '#fff'
  },
  tabTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
    margin: 0
  },
  checkboxSection: {
    '& .MuiFormGroup-root': {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: '8px 20px',
      alignItems: 'flex-start'
    },
    '& .MuiFormControlLabel-root': {
      margin: '2px 0',
      alignItems: 'center',
      display: 'flex',
      flex: '0 1 auto',
      minWidth: 'max-content',
      '& .MuiFormControlLabel-label': {
        fontSize: '14px',
        color: '#333',
        whiteSpace: 'nowrap'
      },
      '& .MuiCheckbox-root': {
        padding: '4px 8px 4px 4px'
      }
    }
  }
});

// const { version } = require('@vega/aitutor/package.json');

const staticProdModelList = [
  { id: '1', title: 'ETEXT2_PXE' },
  { id: '2', title: 'RPLUS_EPUB' },
  { id: '3', title: 'ETEXT2_CITE' },
  { id: '4', title: 'ETEXT_EPUB_BRONTE' },
  { id: '5', title: 'ETEXT_BV_BRONTE' },
  { id: '6', title: 'EXTERNAL_ACTIVEHUB' },
  { id: '7', title: 'EXTERNAL_THUB' },
  { id: '8', title: 'RPLUS_PDF' },
  { id: '9', title: 'ET1_PDF' },
  { id: '10', title: 'ETEXT_PDF' },
  { id: '11', title: 'ETEXT1_PDF' },
  { id: '12', title: 'EXTERNAL_PVS' }
];

const DynamicTestFields = () => {
  const history = useHistory();
  const classes = useStyles();
  const [tenant, setTenant] = useState('');
  const [tenants, setTenants] = useState([]);
  const [uniqueGraphNames, setUniqueGraphNames] = useState([]);
  // const [selectedVersion, setSelectedVersion] = useState('');
  const [courseIdValue, setCourseIdValue] = useState('');
  const [autoCompleteText, setAutoCompleteText] = useState('');
  const [activeTab, setActiveTab] = useState('general');
  const [graphsObj, setGraphsObj] = useState(null);
  const [inputValue, setInputValue] = useState({
    berlinEnv: '',
    tenantId: '',
    tenantKey: '',
    tenantName: '',
    courseId: '',
    productModel: '',
    graphName: '',
    graphId: '',
    version: '',
    pageId: '',
    userId: '',
    message: '',
    tutorName: '',
    botName: 'Berlin Bot',
    channelId: '',
    expandMode: false,
    enableProblemSolveFeature: true,
    showRecommendedPrompts: true,
    AIEnableHigherOrderSuggestion: true,
    AIEnableNewValidateAnswer: true,
    AIEnableQuizRandomization: true,
    AIEnableAIShowChannelVideos: true,
    AIEnableAgentic: true,
    enableExplainQuizOptions: '',
    showSummary: false,
    showPractice: false,
    showExplain: false,
    // Hidden Canned Messages configuration
    isWelcomeMessageFromTestBed: true,
    bookTitle: false,
    bookTitlePreText: false,
    bookTitleSubText: false,
    recommendationsHeading: false,
    ctaButtonHeadingWithRecommendationPills: false,
    ctaButtonHeadingWithOutRecommendationPills: false,
    newTopic: false
  });

  // const [graphNames, setGraphNames] = useState([]);
  const [bookDataList, setBookDataList] = useState([]);

  useEffect(() => {
    const getTenantsConfig = async () => {
      const tokenValue = utils.getToken();
      const headers = {
        Authorization: `Bearer ${tokenValue}`
      };
      try {
        const response = await axios.post(
          `${env.EVERGREEN_API_BASE_URL}${constants.GET_TENANTS_CONFIG_DATA_URL}`,
          {},
          { headers }
        );
        if (response && response.data && response.data.data) {
          setTenants(response.data.data);
        }
      } catch (error) {
        const notification = {
          open: true,
          message: 'Error fetching tenants',
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    };

    getTenantsConfig();
  }, []);

  useEffect(() => {
    const token = utils.getToken();
    const fetchGraphs = async () => {
      try {
        const response = await axios.get(`${env.EVERGREEN_API_BASE_URL}/graphs`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'x-berlin-tenant-id': inputValue.tenantId
          }
        });
        if (response.data.success) {
          const allGraphs = response.data.graphs.filter((g) => g.isActive);
          setGraphsObj(allGraphs); // keep full list for versions
          const uniqueGraphNamesList = Array.from(new Map(allGraphs.map((g) => [g.filename, g])).values()).map((g) => ({
            graphName: g.name,
            filename: g.filename,
            graphId: g.graphId
          }));
          setUniqueGraphNames(uniqueGraphNamesList); // new state for unique graph names dropdown
        } else {
          // error handling
        }
      } catch (err) {
        // error handling
      }
    };
    if (inputValue.tenantId) {
      fetchGraphs();
    }
  }, [inputValue.tenantId]);

  useEffect(() => {
    setInputValue((prevInput) => ({ ...prevInput, courseId: '', graphName: '', graphId: '' }));
  }, [inputValue.tenantId]);

  useEffect(() => {
    const tokenValue = utils.getToken();
    const getBookData = async () => {
      // Get tenant name first before calling the API
      const selectedTenant = tenants.find((t) => t.tenantId === inputValue.tenantId);
      const tenantName = selectedTenant?.name;

      // Set autobahn to true only when tenant name is PVS, false for all others
      const isAutobahnEnabled = tenantName === constants.PVS;

      // Build headers using utility method
      const tenantHeaders = utils.buildHeadersWithTenantId({ tenantId: inputValue.tenantId });
      const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${tokenValue}`,
        ...tenantHeaders
      };

      const response = await axios.get(
        `${env.AI_ADMIN_SERVICES}/api/v1/tenant/identifiers?autobahn=${isAutobahnEnabled}`,
        { headers }
      );
      if (response && response.data && response.data.data) {
        const bookData = response?.data?.data;

        if (bookData && Array.isArray(bookData)) {
          // const bookOptions = bookData.map((book) => `${book.title} (${book.bookId})`);
          setBookDataList(bookData);
        }
      }
    };
    if (inputValue.tenantId) {
      getBookData();
    }
  }, [inputValue.tenantId, tenants]);

  useEffect(() => {
    const tenantObj = tenants.find((tenantItem) => tenantItem.name === tenant);
    setInputValue({
      ...inputValue,
      tenantId: tenantObj?.tenantId,
      tenantKey: tenantObj?.tenantKey,
      tenantName: tenantObj?.name,
      tutorName: tenantObj?.title,
      productModel: tenantObj?.name === constants.PVS ? 'EXTERNAL_PVS' : ''
    });
  }, [tenant]);

  const handleInputChange = (event) => {
    const {
      target: { name, value, type, checked }
    } = event;
    if (type === 'checkbox') setInputValue((prevInput) => ({ ...prevInput, [name]: checked }));
    else setInputValue((prevInput) => ({ ...prevInput, [name]: value }));
  };

  const handleTenant = (event) => {
    setTenant(event.target.value);
  };

  const handleSave = () => {
    const stringifiedObject = JSON.stringify(inputValue);
    const safeString = encodeURIComponent(stringifiedObject);
    const base64String = btoa(safeString);
    history.push(`/configure/${inputValue.tenantName}/agentic?configs=${base64String}`); // Pass the data via state
  };

  const onInputChange = (event, newInputValue) => {
    setCourseIdValue(newInputValue);
  };

  const onAutoCompleteChange = (event, newValue) => {
    setInputValue((prevInput) => ({ ...prevInput, courseId: newValue !== null ? newValue.bookId : '' }));
  };

  const handleGraphNameChange = (event, selected) => {
    if (selected) {
      const selectedGraph1 = graphsObj.find((g) => g.filename === selected.filename);
      setInputValue((prev) => ({
        ...prev,
        graphName: selectedGraph1.name,
        graphId: selectedGraph1.graphId
      }));
      setAutoCompleteText(selected.graphName);
    } else {
      setInputValue((prev) => ({ ...prev, graphName: '', graphId: '', version: '' }));
      setAutoCompleteText('');
      // setSelectedVersion('');
    }
  };

  const handleVersionChange = (event) => {
    const versionGraph = event.target.value;
    if (versionGraph) {
      setInputValue((prev) => ({
        ...prev,
        version: `${versionGraph}`
      }));
    }
  };

  const tabs = [
    {
      id: 'general',
      label: 'General',
      checkboxes: [
        { name: 'enableProblemSolveFeature', label: 'Problem Solve Feature' },
        { name: 'showRecommendedPrompts', label: 'Recommended Prompts' },
        { name: 'AIEnableHigherOrderSuggestion', label: 'Higher Order Suggestion' },
        { name: 'AIEnableNewValidateAnswer', label: 'New Validate Answer' },
        { name: 'AIEnableQuizRandomization', label: 'Quiz Randomization' },
        { name: 'AIEnableAIShowChannelVideos', label: 'AI Channel Videos' },
        { name: 'AIEnableAgentic', label: 'Agentic AI' }
      ]
    },
    {
      id: 'chatbot-ai',
      label: 'ChatBot AI Options',
      checkboxes: [
        { name: 'showSummary', label: 'Show Summary' },
        { name: 'showPractice', label: 'Show Practice' },
        { name: 'showExplain', label: 'Show Explain' }
      ]
    }
  ];

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (!currentTab) return null;

    return (
      <div className={classes.checkboxSection}>
        <div className={classes.tabTitleRow}>
          <Typography className={classes.tabTitle}>{currentTab.label}</Typography>
        </div>
        <FormControl component="fieldset">
          <FormGroup>
            {currentTab.checkboxes.map((checkbox) => (
              <FormControlLabel
                key={checkbox.name}
                control={
                  <Checkbox
                    name={checkbox.name}
                    onChange={handleInputChange}
                    checked={inputValue[checkbox.name] || false}
                    color="primary"
                  />
                }
                label={checkbox.label}
                labelPlacement="end"
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>
    );
  };

  return (
    <>
      <div className={classes.flexBorder}>
        <Box>
          <Grid item xs={16}>
            <Typography variant="h5" align="center" gutterBottom spacing={9}>
              Configure AI Study Tools
            </Typography>
          </Grid>
        </Box>
        <Box sx={{ width: '100%', top: '13%' }}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* eslint-disable */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="tenant">Select Tenant</InputLabel>
                    <Select
                      labelId="tenant-label"
                      label="Select Tenant"
                      name="tenant"
                      onChange={handleTenant}
                      value={tenant}
                    >
                      {tenants.map((t) => (
                        <MenuItem key={t.name} value={t.name}>
                          {t.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    label="Tenant ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tenantId"
                    onChange={handleInputChange}
                    value={inputValue.tenantId}
                    variant="outlined"
                    required
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Tenant Key"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tenantKey"
                    onChange={handleInputChange}
                    value={inputValue.tenantKey}
                    variant="outlined"
                    required
                  />
                  {/* <TextField
                    label="Product Model"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="productModel"
                    onChange={handleInputChange}
                    value={inputValue.productModel}
                    variant="outlined"
                    required
                  /> */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="productModel">Product Model</InputLabel>
                    <Select
                      label="Product Model"
                      name="productModel"
                      onChange={handleInputChange}
                      value={inputValue.productModel}
                    >
                      {staticProdModelList.map((prodModel) => {
                        return <MenuItem value={prodModel.title}>{prodModel.title}</MenuItem>;
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* eslint-disable */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="expandMode">Expand Mode</InputLabel>
                    <Select
                      label="Expand Mode"
                      name="expandMode"
                      onChange={handleInputChange}
                      value={inputValue.expandMode}
                    >
                      <MenuItem value={true}>TRUE</MenuItem>
                      <MenuItem value={false}>FALSE</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="berlinEnv">Berlin Environment</InputLabel>
                    <Select
                      label="Berlin Environment"
                      name="berlinEnv"
                      onChange={handleInputChange}
                      value={inputValue.berlinEnv}
                    >
                      <MenuItem value={'prod'}>Prod</MenuItem>
                      <MenuItem value={'ppe'}>Pre Prod</MenuItem>
                      <MenuItem value={'stage'}>Stage</MenuItem>
                      <MenuItem value={'qa'}>Dev</MenuItem>
                      <MenuItem value={'local'}>Local</MenuItem>
                    </Select>
                  </FormControl>

                  {/* eslint-disable */}
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  {/* <TextField
                    label="Course ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="courseId"
                    onChange={handleInputChange}
                    value={inputValue.courseId}
                    variant="outlined"
                    required
                  /> */}
                  {/* <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <InputLabel id="courseId">Select Course ID</InputLabel>
                    <Select
                      labelId="courseId-label"
                      label="Select Course ID"
                      name="courseId"
                      onChange={handleInputChange}
                      value={inputValue.courseId}
                    >
                      {bookDataList.map((t) => (
                        <MenuItem key={t.title} value={t.bookId}>
                          {`${t.title} (${t.bookId})`}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl> */}
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                    <AutocompleteComponent
                      options={bookDataList}
                      onAutoCompleteChange={onAutoCompleteChange}
                      onInputChange={onInputChange}
                      stateVal={courseIdValue}
                      errorVal=""
                      name="courseId"
                      label="Course Id *"
                    />
                  </FormControl>
                  <TextField
                    label="Heading"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="tutorName"
                    onChange={handleInputChange}
                    value={inputValue.tutorName}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Page ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="pageId"
                    onChange={handleInputChange}
                    value={inputValue.pageId}
                    variant="outlined"
                  />
                  <TextField
                    label="Bot Name"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="botName"
                    onChange={handleInputChange}
                    value={inputValue.botName}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <FormControl sx={{ mt: 1, width: '45%' }} size="small">
                    <InputLabel id="enableExplainQuizOptions">Enable Explain Quiz Options</InputLabel>
                    <Select
                      label="Enable Explain Quiz Options"
                      name="enableExplainQuizOptions"
                      onChange={handleInputChange}
                      value={inputValue.enableExplainQuizOptions}
                    >
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                    </Select>
                  </FormControl>
                  {inputValue.AIEnableAgentic && (
                    <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                      {uniqueGraphNames.length > 0 ? (
                        <Autocomplete
                          options={uniqueGraphNames}
                          getOptionLabel={(option) => option.graphName}
                          isOptionEqualToValue={(option, value) => option.graphId === value.graphId}
                          inputValue={autoCompleteText}
                          value={uniqueGraphNames.find((option) => option.graphId === inputValue.graphId) || null}
                          onInputChange={(event, value) => setAutoCompleteText(value)}
                          onChange={handleGraphNameChange}
                          onBlur={() => {
                            const matched = uniqueGraphNames.find((g) => g.graphName === autoCompleteText);
                            if (!matched) {
                              setInputValue((prev) => ({ ...prev, graphName: '', graphId: '', version: '' }));
                              setAutoCompleteText('');
                            }
                          }}
                          ListboxProps={{
                            sx: {
                              maxHeight: 250,
                              overflowX: 'auto',
                              whiteSpace: 'nowrap',
                              width: 'auto', // optional
                              minWidth: 400 // optional: ensure it's not too narrow
                            }
                          }}
                          renderOption={(props, option) => (
                            <ListItem {...props} style={{ display: 'block', padding: '8px 16px' }}>
                              <Typography>{option.graphName}</Typography>
                              <Typography variant="caption" color="textSecondary" style={{ wordBreak: 'break-all' }}>
                                {option.graphId}
                              </Typography>
                            </ListItem>
                          )}
                          renderInput={(params) => (
                            <TextField
                              size="small"
                              variant="outlined"
                              required
                              {...params}
                              label="Graph Name"
                              InputProps={{
                                ...params.InputProps,
                                style: { height: 41, padding: 0 },
                                inputProps: { ...params.inputProps, style: { padding: '6px 8px' } }
                              }}
                              InputLabelProps={{ style: { fontSize: '0.9rem', top: '-7px' } }}
                            />
                          )}
                        />
                      ) : (
                        <TextField disabled size="small" variant="outlined" label="No Graph Name Found" />
                      )}
                    </FormControl>
                  )}
                </Box>
              </Grid>
            </Grid>

            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="Channel Id"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="channelId"
                    onChange={handleInputChange}
                    value={inputValue.channelId}
                    variant="outlined"
                  />
                  {inputValue.AIEnableAgentic && (
                    <FormControl sx={{ mt: 1, width: '45%' }} size="small" required>
                      {uniqueGraphNames.length > 0 ? (
                        <>
                          <InputLabel id="version-label">Version</InputLabel>
                          <Select
                            labelId="version-label"
                            label="Version"
                            value={inputValue?.version}
                            onChange={handleVersionChange}
                            disabled={!inputValue?.graphName}
                          >
                            {graphsObj
                              .filter((g) => g.filename === `${inputValue.graphName}.json`) // versions for selected graph name
                              .map((g) => (
                                <MenuItem key={g.version} value={g.version}>
                                  {`Version ${g.version} (${g.lifeCycleStatus})`}
                                </MenuItem>
                              ))}
                          </Select>
                        </>
                      ) : (
                        <TextField disabled size="small" variant="outlined" label="No Version Found" />
                      )}
                    </FormControl>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ display: 'flex', justifyContent: 'space-between', p: '0px 32px' }}>
                  <TextField
                    label="User ID"
                    style={{ minWidth: '45%' }}
                    margin="dense"
                    name="userId"
                    onChange={handleInputChange}
                    value={inputValue.userId}
                    variant="outlined"
                  />
                </Box>
              </Grid>
            </Grid>
            <Grid container direction="row" style={{ justifyContent: 'center' }}>
              <Grid item xs={10} direction="row">
                <Box sx={{ p: '0px 32px' }}>
                  <div className={classes.tabContainer}>
                    {/* Left Panel - Tab Navigation */}
                    <div className={classes.tabNavigation}>
                      {tabs.map((tab) => (
                        <button
                          key={tab.id}
                          className={`${classes.tabButton} ${activeTab === tab.id ? classes.tabButtonActive : ''}`}
                          onClick={() => handleTabChange(tab.id)}
                          style={{
                            backgroundColor: activeTab === tab.id ? '#005d83' : 'transparent',
                            color: activeTab === tab.id ? '#fff' : '#666',
                            fontWeight: activeTab === tab.id ? '600' : '500'
                          }}
                        >
                          {tab.label}
                        </button>
                      ))}
                    </div>

                    {/* Right Panel - Tab Content */}
                    <div className={classes.tabContent}>{renderTabContent()}</div>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <Grid container direction="row" style={{ justifyContent: 'center' }}>
            <Grid item xs={10} direction="row">
              <Box sx={{ display: 'flex', flexDirection: 'column', p: '0px 32px' }}>
                <InputLabel className={classes.subLable}>Welcome Message</InputLabel>
                <TextareaAutosize
                  style={{ width: '100%' }}
                  name="message"
                  onChange={handleInputChange}
                  variant="outlined"
                  minRows={6}
                  maxRows={12}
                  value={inputValue.message}
                />
              </Box>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className={classes.flexContainerBottom}>
          <div className={classes.ButtonClass}>
            <Stack direction="row" spacing={2}>
              <Button
                variant="contained"
                size="small"
                onClick={() => handleSave()}
                sx={{ background: '#005d83' }}
                disabled={[
                  tenant,
                  inputValue.tenantId,
                  inputValue.tenantKey,
                  inputValue.courseId,
                  inputValue.productModel,
                  inputValue.berlinEnv,
                  ...(inputValue.AIEnableAgentic ? [inputValue.graphName, inputValue.version] : [])
                ].includes('')}
              >
                LAUNCH
              </Button>
            </Stack>
          </div>
          <div className={classes.ButtonClass}>
            {/* <div className={classes.versionText}>{`vega/aitutor - ${version}`}</div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default DynamicTestFields;
